<div class="reporte_error_pie_">
    <p class="texto_reporte_error">¿Hay algún error en el sitio? </p><a (click)="renderizarFormularioConsulta()"
        class="a_enlace_reporte_error">Enviar
        reporte</a>
</div>